<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<h1 class="book-title">Raiders from the North</h1>
<p class="sub-title">EMPIRE OF THE MOGHUL</p>
<p class="author">Alex Rutherford</p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="editor">Thomas Dunne Books</p>
<p class="editor1">St. Martin’s Press</p>
<p class="editor1">New York</p>
<p class="image1"><img alt="Images" src="images/fig_tit.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?cb692280